export interface UserNameParts {
  first_name?: string | null;
  last_name?: string | null;
}

/** Formats API user names without adding missing name parts or surrounding whitespace. */
export const getUserName = (name?: string | UserNameParts | null): string => {
  if (typeof name === 'string') {
    return name.trim();
  }

  return [name?.first_name?.trim(), name?.last_name?.trim()].filter(Boolean).join(' ');
};
